export const stripEmojis = (text: string): string => {
	// Match emojis, format characters, and control characters, but exclude ASCII alphanumerics
	// The \p{Emoji} property can incorrectly match regular digits in some engines, so we explicitly exclude ASCII alphanumerics
	const withoutEmojis = text.replace(/(?![0-9A-Za-z])(\p{Emoji}|\p{Cf}|\p{Cc})\s*/gu, '');
	// Remove any remaining special Unicode whitespace characters and variation selectors
	const withoutSpecialWhitespace = withoutEmojis.replace(/[\u200B-\u200D\uFEFF]|\uFE0F/g, '').trim();

	return withoutSpecialWhitespace;
};
